import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { CandidacyJobAndCompanyId, HttpResponse } from "@/types";

/**
 * Used to get company and job id for a candidacy to route to candidate sheet on the pipeline page
 */
export function useGetJobAndCompanyIdForCandidacy({
  candidacyId,
  enabled,
}: {
  candidacyId: string | null;
  enabled: boolean;
}) {
  return useQuery({
    queryKey: ["aviary/candidacy-job-and-company-id", candidacyId],
    queryFn: async () => {
      const path = `aviary/${candidacyId ?? ""}`;
      const res = await guacHttpClient.get<
        CandidacyJobAndCompanyId,
        HttpResponse<CandidacyJobAndCompanyId>
      >(path);
      return res.data;
    },
    enabled: enabled && !!candidacyId,
  });
}
